module.exports = __webpack_public_path__ + "img/curve-Loading.504b535c.gif";